import auth from '@/utils/authentication';

/**
 * 递归裁剪无权限节点。
 * 容器节点若被裁到没有可见子项，则整体丢弃（避免出现空菜单壳）。
 *
 * @param userRole 当前用户在当前团队的角色（members.role）。
 *   传 undefined 表示「角色未知」（userInfo 还没拉到），此时不做角色裁剪 ——
 *   否则 admin 直连 /team/* 会先闪一下 403。拿到角色后再按白名单裁剪。
 */
export function filterByPermission(nodes, userPermission = {}, userRole) {
  const result = [];

  for (const node of nodes) {
    // 角色门禁：声明了 roles 白名单的节点，角色未知或不在白名单里的整棵裁掉
    if (hasRoleGate(node) && !isRoleAllowed(node, userRole)) {
      continue;
    }

    if (!auth(node, userPermission)) {
      continue;
    }

    const children = node.children?.length ? filterByPermission(node.children, userPermission, userRole) : undefined;

    if (!node.component && node.children?.length && !children?.length) {
      continue;
    }

    result.push({ ...node,
      children
    });
  }

  return result;
}

function hasRoleGate(node) {
  return Array.isArray(node.roles) && node.roles.length > 0;
}

function isRoleAllowed(node, userRole) {
  // 角色未知（userInfo 未就绪）时放行，避免误伤；等 userInfo 到了会重新过滤
  if (userRole === undefined) {
    return true;
  }

  return !!node.roles?.includes(userRole);
}